function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1521 4.37207H2.05674C0.921802 4.37207 0 5.25781 0 6.34833V23.0237C0 24.1142 0.921802 25 2.05674 25H14.1521C15.287 25 16.2088 24.1142 16.2088 23.0237V6.34833C16.2035 5.25781 15.2817 4.37207 14.1521 4.37207ZM14.7648 23.0186C14.7648 23.3463 14.4877 23.6125 14.1467 23.6125H2.05141C1.7104 23.6125 1.43332 23.3463 1.43332 23.0186V6.34833C1.43332 6.02066 1.7104 5.75443 2.05141 5.75443H14.1467C14.4877 5.75443 14.7648 6.02066 14.7648 6.34833V23.0186Z",
  fill: "inherit"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7774 0H6.6821C5.54717 0 4.62537 0.885735 4.62537 1.97626C4.62537 2.36025 4.94507 2.66744 5.34469 2.66744C5.74432 2.66744 6.06402 2.36025 6.06402 1.97626C6.06402 1.64859 6.34109 1.38236 6.6821 1.38236H18.7774C19.1184 1.38236 19.3955 1.64859 19.3955 1.97626V18.6516C19.3955 18.9793 19.1184 19.2455 18.7774 19.2455C18.3778 19.2455 18.0581 19.5527 18.0581 19.9367C18.0581 20.3207 18.3778 20.6279 18.7774 20.6279C19.9124 20.6279 20.8342 19.7422 20.8342 18.6516V1.97626C20.8342 0.885735 19.9124 0 18.7774 0Z",
  fill: "inherit"
});

var SvgIconCopy = function SvgIconCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-copy.65e182b0.svg";
export { ForwardRef as ReactComponent };